import React, { useEffect, useContext } from "react";
import styles from "../Profile/Profile.module.css";
import multipleEntry from "../../assests/popup/multipleEntry.svg";
import { useLocation, useNavigate } from "react-router";
import { authentication } from "../../store/firebase-config";
import Context from "../../context/Context";
import { createSearchParams } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";

function CampaignNotPublished({}) {
  return (
    <>
      <div className="fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center z-10 bg-black bg-opacity-[50%] backdrop-blur-xl">
        <div className={styles.deteleme}>
          <img
            src={multipleEntry}
            alt=""
            className="w-[56px] h-[56px] mb-[24px]"
          />
          <p className="text-regular-medium px-[20px] mb-[16px] text-[#FFE100]">
            Campaign Not Available
          </p>
          <p className="text-small text-[#CDCDCD] px-[20px]">
            Your campaign creation is in progress or link incorrect and will be published after
            admin approval. Once approved, admin will be notified through email.
          </p>
        </div>
      </div>
    </>
  );
}

export default CampaignNotPublished;
